
function Footer() {
    return (
    <footer>
        <p className="light" style={{textAlign: 'center'}}>Butter and Salt &copy; 2021</p>
    </footer>
    )
}

export default Footer